import client from '../client';
import type { StoreApp } from '../../types/app';
import type { ApiResponse } from '../../types/api';

export const appsApi = {
  list: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ apps: StoreApp[] }>>(
      `/dashboard/${storeId}/apps`,
    );
    return res.data.data!;
  },

  // External apps cannot be installed inline: they need a real access token and
  // the merchant needs to approve the requested scopes, both of which only come
  // out of the OAuth flow. The API answers those with an authorize URL instead
  // of installing, and the caller sends the merchant there.
  install: async (storeId: string, appId: string) => {
    const res = await client.post<ApiResponse<{ requiresAuthorization?: boolean; authorizeUrl?: string }>>(
      `/dashboard/${storeId}/apps/${appId}/install`,
    );
    return res.data.data ?? {};
  },

  uninstall: async (storeId: string, appId: string) => {
    await client.post(`/dashboard/${storeId}/apps/${appId}/uninstall`);
  },

  // The signature has to be produced server-side (it uses the app's webhook
  // secret), so the dashboard asks for a ready-made URL rather than building one.
  manageUrl: async (storeId: string, appId: string) => {
    const res = await client.get<ApiResponse<{ url: string }>>(
      `/dashboard/${storeId}/apps/${appId}/manage-url`,
    );
    return res.data.data!.url;
  },

  // Scopes are granted on the OAuth consent screen at install time and are
  // read-only in the dashboard, so there is deliberately no updateScopes here.
  updateConfig: async (storeId: string, appId: string, config: Record<string, unknown>) => {
    await client.patch(`/dashboard/${storeId}/apps/${appId}/config`, { config });
  },
};
